// eslint-disable-next-line @typescript-eslint/no-unused-vars
import AlmeWindow from '@alme/ui-web/ref/window';
import WindowHeader from '@alme/ui-web/ref/window-header';
import HeaderBanner from '@alme/ui-web/ref/window-header-banner';
import HeaderToolbar from '@alme/ui-web/ref/window-header-toolbar';
import ConversationArea from '@alme/ui-web/ref/window-conversationarea';
import WindowFooter from '@alme/ui-web/ref/window-footer';
import InputBox from '@alme/ui-web/ref/window-inputbox';
import SkipToContent from '@alme/ui-web/ref/window-skip-to-content';
import LaunchPointWindowModule from '@alme/ui-web/ref/window-launch';
import TimeoutWarningOverlay from '@alme/ui-web/ref/timeout-warning-overlay';
import ScrollBehavior from '@alme/ui-web/ref/conversationarea-scrolltoinput';
import WindowTabletMutator from '@alme/ui-web/ref/window-tablet-mutator';
import MinimizeWindow from '@alme/ui-web/ref/window-minimize';
import ResizeWindow from '@alme/ui-web/ref/window-jquery-resize';
import DragWindow from '@alme/ui-web/ref/window-jquery-drag';
import AlmeMessageRenderer from '@alme/ui-web/ref/message-renderer-alme';
import UserMessageRenderer from '@alme/ui-web/ref/message-renderer-user';
import MessageRendererNotification from '@alme/ui-web/ref/message-renderer-notification';
import { MessageRendererInlineSurveyLinks } from '@alme/ui-web/ref/message-renderer-inline-survey-links';
import FeedbackOverlay from '@alme/ui-web/ref/simple-feedback-overlay';
import NavUrlRenderer from "@alme/ui-web/ref/message-renderer-nav-url";
import { DisplayLinksRenderer, InlineLinksRenderer } from "@alme/ui-web/ref/message-renderer-display-links";
import ErrorMessageRenderer from "@alme/ui-web/ref/message-renderer-errors";
import { settings } from '@alme/ui-web/settings/settings-util';
import CallToActionButtonMessageRenderer from "@alme/ui-web/modules/message-renderer-call-to-action/src/message-renderer-call-to-action";
//custom
import FooterLinks from '../components/renderers/nextit-footer-persistent-links';
import ResizeIcon from '../components/renderers/footer-resize-icon/footer-resize-icon';

function setupAlmeHeader(components, onContactUsPage) {

    const toolbarChildComponents = onContactUsPage ? [] :
    [
        components.minimizeWindow,
        components.resizeWindow,
        components.dragWindow,
    ];

    components.headerToolbar = new HeaderToolbar(null, [], toolbarChildComponents);
    components.headerBanner = new HeaderBanner(null, [], []);

    const headerMutatorModules = onContactUsPage ? 
    []: 
    [
        components.dragWindow,
    ];

    const headerChildComponents = [
        components.headerBanner,
        components.headerToolbar,
        components.liveChatFoundation.UI.header,
    ];

    return new WindowHeader(null, Object.values(headerMutatorModules), Object.values(headerChildComponents));

}

function setupConversationArea(components) {
    components.navUrlRenderer = new NavUrlRenderer(null, components.stepOutIcon);
    components.inlineLinkRenderer = new InlineLinksRenderer(null, components.stepOutIcon);
    components.displayLinkRenderer = new DisplayLinksRenderer(null, components.stepOutIcon);
    components.inlineSurveyLinksRenderer = new MessageRendererInlineSurveyLinks(undefined, components.singleLinkRenderer);
    components.errorRenderer = new ErrorMessageRenderer();
    components.callToActionButtonMessageRenderer = new CallToActionButtonMessageRenderer(undefined, components.singleLinkRenderer);

    const almeMessageComponents = [
        components.navUrlRenderer,
        components.callToActionButtonMessageRenderer,
        components.inlineLinkRenderer,
        components.displayLinkRenderer,
        components.inlineSurveyLinksRenderer,
        components.errorRenderer,
    ];

    components.almeMessageRenderer = new AlmeMessageRenderer(null, [], [], almeMessageComponents);
    components.userMessageRenderer = new UserMessageRenderer();
    components.notificationMessageRenderer = new MessageRendererNotification(null, [], []);

    const conversationAreaMessageComponents = [
        components.almeMessageRenderer,
        components.userMessageRenderer,
        components.notificationMessageRenderer,
        components.liveChatFoundation.UI.input,
        components.liveChatFoundation.UI.response,
        components.liveChatFoundation.UI.connectBanner,
        components.liveChatFoundation.UI.disconnectBanner,
        components.liveChatFoundation.UI.queuedBanner,
    ];

    return new ConversationArea(null, Object.values(conversationAreaMessageComponents), [], []);
}

function setupAlmeFooter(components, onContactUsPage) {
    const inputBoxMutators = [
        components.inputboxLockMutator,
        components.liveChatFoundation.UI.inputBox,
        components.liveChatFoundation.UI.inputBoxButton,
    ];

    components.windowFooterLinks = new FooterLinks(settings, components.singleLinkRenderer);
    components.inputBox = new InputBox(null, [], Object.values(inputBoxMutators), [components.liveChatFoundation.UI.inputBoxButton], []);

    const footerChildComponents = onContactUsPage ?
    [
        components.liveChatFoundation.UI.endChatLink,
        components.inputBox, 
        components.liveChatFoundation.UI.typingNotification,
        components.windowFooterLinks,
    ]:
    [
        components.liveChatFoundation.UI.endChatLink,
        components.inputBox, 
        components.liveChatFoundation.UI.typingNotification,
        components.windowFooterLinks,
        components.resizeIcon,
    ];

    return new WindowFooter(null, [], footerChildComponents);
}

function setupAlmeWindow(components, onContactUsPage) {

    //window components
    components.skipToContent = new SkipToContent();
    components.launchPoint = new LaunchPointWindowModule();
    components.timeoutWarningOverlay = new TimeoutWarningOverlay();
    components.scrollBehavior = new ScrollBehavior();
    components.windowTabletMutator = new WindowTabletMutator();
    components.feedbackOverlay = new FeedbackOverlay(undefined, components.singleLinkRenderer);
    
    if (!onContactUsPage) {
        components.minimizeWindow = new MinimizeWindow();
        components.resizeWindow = new ResizeWindow();
        components.dragWindow = new DragWindow();
        components.resizeIcon = new ResizeIcon(settings);
    }

    components.windowHeader = setupAlmeHeader(components, onContactUsPage);
    components.conversationArea = setupConversationArea(components, onContactUsPage);
    components.windowFooter = setupAlmeFooter(components, onContactUsPage);

    const fixedPositionMutator = (params) => {
        const style = Object.assign({ position: 'fixed' }, params.style);
        return Object.assign({}, params, { style });
    };

    const almeWindowMutators = onContactUsPage ?
    [] :
    [
        components.minimizeWindow,
        components.launchPoint,
        components.liveChatFoundation.UI.window,
        components.resizeWindow,
        components.windowTabletMutator,
        { getMutator: () => fixedPositionMutator },
    ];

    const almeWindowChildComponents = [
        components.windowHeader,
        components.skipToContent,
        components.conversationArea,
        components.windowFooter,
        components.launchPoint,
        components.timeoutWarningOverlay,
        components.singleLinkRenderer,
        components.feedbackOverlay,
        components.ttsResponseHandler,
        components.liveChatFoundation.UI.endChatWarningOverlay,

    ];

    // Add class to make window fixed position
    const extraClass = `nit-${ onContactUsPage ? 'embedded' : 'resizable'}`,
        windowClassName = `${settings.classNames.windowClassName} ${extraClass}`,
        classNames = Object.assign({}, settings.classNames, { windowClassName }),
        windowSettings = Object.assign({}, settings, { classNames });

    components.almeWindow = new AlmeWindow(windowSettings, Object.values(almeWindowMutators), almeWindowChildComponents);
    return components;
}

export {
    setupAlmeWindow
};



// WEBPACK FOOTER //
// ./src/setup-window-components.js